import { ITEM_TAG } from '@libs/constants';
import { checkIfReminderExists, excludeIdFromUrl, findRemindId } from '../helpers/reminder';

type IInitialState = typeof import('../store/defaultState').initialState;

interface ItemInterface {
    paId: string;
    listingId: string;
    tags: { scheme: string }[];
    categories: string[];
}

export function useReminderItem(item: Partial<ItemInterface>, allReminders: any[] = []) {
    const reduxReminderslist = allReminders;
    const remindersList = reduxReminderslist ? Object.values(reduxReminderslist) : [];

    const paId = item?.paId ? excludeIdFromUrl(item.paId) : '';
    const listingId = item?.listingId ? excludeIdFromUrl(item.listingId) : '';

    const isReminded = checkIfReminderExists(remindersList, paId, listingId);
    const reminderId = findRemindId(remindersList, paId, listingId);

    const isComingSoonItem = !!(
        item?.tags?.find((data) => data.scheme === ITEM_TAG.COMING_SOON) ||
        (Array.isArray(item?.categories)
            ? item.categories.find((data) => data === ITEM_TAG.COMING_SOON)
            : item?.categories === ITEM_TAG.COMING_SOON)
    );

    return { isComingSoonItem, remindersList, paId, listingId, isReminded, reminderId };
}
